<template>
    <div class="joinUs">
        <ul class="lists">
            <li v-for="(n,i) in workTypeArr" :key="i" @click="getJobInfo(i,'','1')"
                :class="{ lists_active:work_type_index === i}">{{$t(n)}}
            </li>
        </ul>
        <div class="career_list">
            <form @submit.prevent action="#" class="joinUs_search">
                <input type="search" :placeholder="$t('enter_key')" v-model="keywords" @blur="searchIos"
                       @keypress="searchAndroid">
                <i></i>
            </form>

            <ul class="careers_name">
                <li v-for='(n,i) in tagList' @click="getJobInfo('',n.company,'1')" :key="i">{{n.company}}</li>
            </ul>
            <div v-if="isJobData">
                <careerList v-for="(n,o) in careerListInfo" :careerInfo="n" :key="o"></careerList>
                <div v-html="pagination" class="paging_numbers" ref="pagination"></div>
            </div>
            <div style='width: 100%;text-align: center;margin: 75px 0 ;' v-else><img
                    src='../../assets/images/no_page.png' alt='' width="160"></div>
        </div>
    </div>
</template>

<script>
import careerList from "../../components/endPage/careerList";
export default {
  name: "joinUs",
  components: {
    careerList
  },
  data: function() {
    return {
      tagList: [],
      work_type_index: 0,
      workTypeArr: [
        "work_type[0]",
        "work_type[1]",
        "work_type[2]",
        "work_type[3]"
      ],
      careerListInfo: [],
      isJobData: true,
      keywords: "",
      pagination: ""
    };
  },
  created: function() {
    this.getJobInfo(0, "", "1");
    this.$store.commit("set_current", "-1");
    this.$store.commit("set_title", "footerNav[0]");
  },
  methods: {
    getJobInfo: function(i, keys, p) {
      this.work_type_index = i;
      this.keywords = keys;
      let n = parseInt(i) + parseInt("1");
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + "/home/job/jobList?p=" + p,
        dataType: "json",
        data: {
          work_type: n,
          key_word: this.keywords,
          lang: window.$lang
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.tagList = res.data.result.tag;
            this.careerListInfo = res.data.result.jobs;
            this.pagination = res.data.result.show;
            this.isJobData = this.careerListInfo.length !== 0;
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    searchIos() {
      //ios点击完成失去焦点搜索
      this.getJobInfo("", this.keywords, "1");
    },
    searchAndroid(event) {
      //android点击搜索，未能失去焦点，故失去焦点事件无法触发，单可以调用键盘事件处理
      if (event.keyCode === 13) {
        //如果按的是enter键 13是enter
        event.preventDefault(); //禁止默认事件（默认是换行）
        this.getJobInfo("", this.keywords, "1");
      }
    },
    GetDom() {
      var DOM = this.$refs.pagination;
      var a_dom = DOM.getElementsByTagName("a");
      var that = this;
      for (var i = 0; i < a_dom.length; i++) {
        a_dom[i].onclick = function() {
          document.body.scrollTop = document.documentElement.scrollTop = 0;
          that.getJobInfo(that.work_type_index, that.keywords, this.dataset.p);
        };
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.GetDom();
    }, 1000);
  },
  computed: {
    //计算属性，
    weburl: function() {
      return this.$store.state.weburl;
    }
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/nav";

.joinUs {
  width: @width;
  .career_list {
    .box-sizing;
    width: @width;
    padding: 20px;
    .joinUs_search {
      width: @width;
      height: @height + 2;
      .box-sizing;
      padding-left: 17px;
      .border-radius(25px);
      .border(1px; solid; tint(@word, 50%));
      margin-bottom: 15px;
      input {
        width: 90%;
        height: @height;
        float: left;
        line-height: @height;
      }
      i {
        float: left;
        margin-top: 5px;
        width: 10%;
        height: @height - 6;
        background: url(../../assets/images/xuebi_28.png) no-repeat -1px -12px;
        background-size: 19px auto;
      }
    }
    .careers_name {
      display: flex;
      flex-wrap: wrap;
      li {
        padding: 7px 10px;
        background: darken(@bg, 5%);
        color: @word;
        font-size: 0.8rem;
        margin-right: 5px;
        .border-radius(20px);
        margin-bottom: 10px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  @height: 30px;
}

.lists_active {
  color: @brick_red;
  &:after {
    background: @brick_red;
  }
}
</style>
<style>
@import "../../assets/css/pagination.css";
</style>
